import styles from "../Stats.module.css";
import gameAssets from "@themed-assets";
import { useNavigate } from "react-router";

export const StatsHeader = ({ onInfoClick, isA23 }) => {

    const navigate = useNavigate();

    return (
        <div className={`${styles.headerTitle}`}>
          <div className="flex justify-between">
            <div className="back-my-stats flex justify-start gap-2">
              <img
                src={gameAssets.backArrow}
                alt="Back Arrow"
                width={24}
                height={24}
                onClick={() => navigate("/")}
              />
              <div className="font-medium text-16">My Stats</div>
            </div>
            <img
              src={gameAssets.InfoIcon}
              alt="Info"
              width={24}
              height={24}
              onClick={onInfoClick}
            />
          </div>
          <div className={`${isA23 ? styles.gradientSeaDarkBorder : styles.addaHeaderBorder} mt-3`}></div>
        </div>
    )
}